export default [
  /ResizeObserver/i,
  /Network Error/i,
  /Request failed with status code (403|401)/i,
  /USER_IS_LOGIN/i,
  /fullscreen error/i,
  /USER_CAN_DOWNLOAD_CONTRACT/i,
  /USER_IS_BUSINESS/i,
  /undefined is not a function (near '...Promise.allSettled...')/i,
  /getReadModeConfig/i,
  /getReadModeRender/i,
  /getReadModeExtract/i,
  /Loading CSS chunk/i,
  /Loading chunk/i,
  /invalid token/i,
  /Request aborted/i,
  /Your operations are too frequent/i,
]

export const apiIgnoreError: string[] = [
  'No international fax for free users',
  'Free users can only send faxes once every five minutes',
  'Incorrect verification code',
  'The verification code has expired',
  'Insufficient pages or credits left',
  'Your operations are too frequent',
  'The number has been blocked as it is a special number. Please check if the number is correct. Feel free to contact us if needed',
]

export const isApiIgnoreError = (msg: string) => {
  return apiIgnoreError.some((it) => `${msg}`.includes(it))
}
